interface PriceSectionProps {
  onPurchase: () => void;
  isLoading: boolean;
}

const PriceSection: React.FC<PriceSectionProps> = ({ onPurchase, isLoading }) => {
  return (
    <section className="bg-black text-white py-16 px-4">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          Why only $9.99?
        </h2>
        
        <p className="text-xl text-gray-300 mb-8 leading-relaxed">
          Because I want it to be accessible but still respected. And honestly, you're buying a year of trial-and-error condensed into one guide.
        </p>
        
        <div className="bg-gradient-to-r from-cyan-400/10 to-cyan-600/10 border-2 border-cyan-400 rounded-xl p-8 mb-8">
          <p className="text-5xl font-bold text-cyan-400 mb-2">$9.99</p>
          <p className="text-gray-400 line-through text-xl mb-4">Regular price: $29.99</p>
          <p className="text-gray-300 mb-6">Launch special — save 79%</p>
        </div>
        
        <button
          onClick={onPurchase}
          disabled={isLoading}
          className={`bg-cyan-400 hover:bg-cyan-300 text-black font-bold py-4 px-12 rounded-lg text-xl transition-all transform hover:scale-105 shadow-lg shadow-cyan-400/50 ${
            isLoading ? 'opacity-50 cursor-not-allowed' : ''
          }`}
        >
          {isLoading ? 'Processing...' : 'Get the PDF – $9.99'}
        </button>
        
        <p className="text-sm text-gray-400 mt-4">
          Instant delivery. No upsells. No bullshit.
        </p>
      </div>
    </section>
  );
};

export default PriceSection;